import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportHistoryCheckAwtgRanPathParameter } from '@api/hitoryCheck';

import { TAwtgRanExportParameterDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { HC_AWTG_RAN_PATH_PARAMETER_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateExportHcAwtgRanPathParameterReturnType {
	exportParameters: UseMutateFunction<any, any, TAwtgRanExportParameterDTO, any>;
}

export const useMutateExportHcAwtgRanPathParameter = (): IUseMutateExportHcAwtgRanPathParameterReturnType => {
	const dispatch = useAppDispatch();

	const { mutate } = useMutation<TAwtgRanExportParameterDTO>({
		mutationKey: [HC_AWTG_RAN_PATH_PARAMETER_EXPORT],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: exportHistoryCheckAwtgRanPathParameter,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportParameters: mutate };
};
